import { render, staticRenderFns } from "./PreviewZoom.vue?vue&type=template&id=ba10b60c&lang=pug"
import script from "./PreviewZoom.vue?vue&type=script&lang=js"
export * from "./PreviewZoom.vue?vue&type=script&lang=js"
import style0 from "./PreviewZoom.vue?vue&type=style&index=0&id=ba10b60c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports